import { transactionsListHandler } from './transactionsList';

const queries = [transactionsListHandler];

export default queries;
